export default source => source
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
